export class PriceRobotMessage{
    public message: string;
    public isError: boolean;

    constructor(message: string, isError: boolean) {
        this.message = message;
        this.isError = isError;
    }

    public clear() {
        this.message = '';
    }
}
